import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

export function CompanyLogo({
  company,
}: {
  company: {
    name: string;
    fullLogo: string;
    logo: string;
  };
}) {
  const { open: isSidebarOpened, openMobile: isSidebarMobileOpened } =
    useSidebar();

  const isExpanded = isSidebarOpened || isSidebarMobileOpened;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          className="!bg-transparent !hover:bg-transparent hover:cursor-auto data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <div className="flex items-center justify-center text-primary">
            {isExpanded ?
              <div className="ml-2 flex flex-col items-start">
                <h2 className="text-2xl font-bold italic bg-gradient-to-r from-[#71CEE2] to-[#EC5F93] text-transparent bg-clip-text " >
                  {company.name}
                </h2>
              </div>
              :
              <img
                src={company.logo}
                alt={`${company.name} logo`}
              // className=" w-auto"
              />
            }

          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
